import * as service from './service'
export default {
  namespace: 'honourKnightScoreRecord',
  state: {
    demoData: {}
  },
  effects: {
    * getScoreRecord ({ payload }, { call, put }) {
      const res = yield call(service.scoreRecord, payload)
      if (res.data.status === 200) {
        return res.data.data
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
